import { Constants } from '@/utils/constants';
import Router from 'next/router';
import Button from '../atoms/Button';
import Heading from '../atoms/Heading';

type Props = {
  UpgradestsResult: string;
  UpgradeJudgeResult: string;
  Upgradeispno: string;
  UpgradeLinkstate: string;
};

/**
 * 10G アップグレード契約導線のサマリーテンプレート。
 * 可否判定結果と紐づけ状態をもとに、申込導線または申込済み表示を切り替える。
 */
const upgradeContract = ({
  UpgradestsResult,
  UpgradeJudgeResult,
  Upgradeispno,
  UpgradeLinkstate,
}: Props) => {
  /** STS の紐づけ状態に応じて次の遷移先を決める。 */
  const UpgradeButton = () => {
    if (UpgradeLinkstate === Constants.LINK.LINKOK) {
      // 紐づけ状態STSが紐づけありの場合は「アップグレード申込完了画面」に遷移
      Router.push('/contract/g10upgrade/completed');
    }
    if (UpgradeLinkstate === Constants.LINK.LINKNG) {
      // 紐づけ状態STSが紐づけなしの場合は「アップグレード申込条件説明画面」に遷移
      Router.push('/contract/g10upgrade');
    }
  };

  // 可否判定が OK かつ紐づけ未完了の時だけ、新規申込導線を表示する。
  if (
    UpgradeJudgeResult === Constants.Upgrade.UPGRADEOK &&
    UpgradestsResult === Constants.STS.NOTSTSNG
  ) {
    return (
      <>
        <Heading as='h3'>10Gアップグレードお申込みのお客様</Heading>
        10Gアップグレードをご利用されるお客様は下記よりお手続きをお願いします。
        <br />
        10G アップグレードの詳細は
        <a href='https://www.nuro.jp/hikari/upgrade/?SmRcid=al_mpg' target='_blank'>
          こちら
        </a>
        <div className='m-button align-center'>
          <Button variant='secondary' type='submit' onClick={UpgradeButton}>
            10Gアップグレードの手続き
          </Button>
        </div>
      </>
    );
  }

  // すでに 10G 側との紐づけが完了している場合は、申込済み情報のみを表示する。
  if (
    UpgradeJudgeResult === Constants.Upgrade.UPGRADEOK &&
    UpgradestsResult === Constants.STS.STSOK
  ) {
    return (
      <>
        <Heading as='h3'>10Gアップグレードお申込みのお客様</Heading>
        10Gアップグレードはお申込済みです。
        <table>
          <tbody>
            <tr>
              <th className='m-table__th'>10Gプランお客様番号</th>
              <td className='m-table__td'>{Upgradeispno}</td>
            </tr>
          </tbody>
        </table>
      </>
    );
  }
  if (
    UpgradeJudgeResult === Constants.Upgrade.NOTUPGRADENG &&
    UpgradeLinkstate === Constants.LINK.LINKNG
  ) {
    return null;
  }
  return null;
};

upgradeContract.defaultProps = {
  UpgradeJudgeResult: undefined,
  UpgradestsResult: undefined,
};

export default upgradeContract;
